export default {
  options: {
    chartTypeSourcePath: ['typeSourcePath', ''],
    product: ['product', 'v3'],
    insertMode: ['insertMode', 'replace'],
    safeMode: ['safeMode', !0],
    overlayButton: ['overlayButton'],
    containerBackgroundColor: ['containerBackgroundColor', '#ffffff'],
    containerBackgroundOpacity: ['containerBackgroundOpacity', 1],
    containerClassName: ['containerClassName', 'fusioncharts-container'],
    chartType: ['type'],
    baseChartMessageFont: ['baseChartMessageFont', 'Verdana,sans'],
    baseChartMessageFontSize: ['baseChartMessageFontSize', '10'],
    baseChartMessageColor: ['baseChartMessageColor', '#666666'],
    baseChartMessageImageHAlign: ['baseChartMessageImageHAlign', 'middle'],
    baseChartMessageImageVAlign: ['baseChartMessageImageVAlign', 'middle'],
    baseChartMessageImageAlpha: ['baseChartMessageImageAlpha', 100],
    baseChartMessageImageScale: ['baseChartMessageImageScale', 100],
    dataLoadStartMessage: ['dataLoadStartMessage', 'Retrieving data. Please wait.'],
    dataLoadErrorMessage: ['dataLoadErrorMessage', 'Error in loading data.'],
    dataInvalidMessage: ['dataInvalidMessage', 'Invalid data.'],
    dataEmptyMessage: ['dataEmptyMessage', 'No data to display.'],
    typeNotSupportedMessage: ['typeNotSupportedMessage', 'Chart type not supported.'],
    browserNotSupportedMessage: ['browserNotSupportedMessage', 'This browser is not supported.'],
    loadMessage: ['loadMessage', 'Loading chart. Please wait.'],
    renderErrorMessage: ['renderErrorMessage', 'Unable to render chart.'],
    messageURL: ['messageURL', ''],
    containerElementId: ['renderAt'],
    renderer: ['renderer'],
    containerElementType: ['containerElementType'],
    showChartLoadingMessage: ['showChartLoadingMessage', !0],
    visibilityTrackingInterval: 300,
    events: ['events', {}]
  },
  jsVars: {},
  attributes: {
    lang: ['lang', 'EN'],
    id: ['id']
  },
  link: ['link'],
  width: ['width', '400'],
  height: ['height', '300']
};